import { h } from '@stencil/core';
import { pesIconSizes } from '@pes-ui/utils';
export class Banner {
  constructor() {
    this.url = '';
    this.target = '_self';
    this.icon = 'segment_retail';
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    const anchorProps = this.url ? { href: this.url, target: this.target } : {};
    return (h("a", Object.assign({ class: "banner" }, anchorProps), h("pes-icon", { class: "banner__corner-icon", color: "alternative", size: pesIconSizes.MICRO }, this.icon), h("slot", null)));
  }
  static get is() { return "pes-banner"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["banner.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["banner.css"]
    };
  }
  static get properties() {
    return {
      "url": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "http://some.domain/some/path#some-hash?some=query"
            }],
          "text": "URL for redirection after click."
        },
        "attribute": "url",
        "reflect": false,
        "defaultValue": "''"
      },
      "target": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "target attribute for anchor tag"
        },
        "attribute": "target",
        "reflect": false,
        "defaultValue": "'_self'"
      },
      "icon": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "segment_retail"
            }],
          "text": "Icon at the top left corner."
        },
        "attribute": "icon",
        "reflect": false,
        "defaultValue": "'segment_retail'"
      }
    };
  }
  static get elementRef() { return "el"; }
}
